<template>
    <div id="app">
        <b-container>
            <b-row>
                <b-col>
                    <h1>{{ title }}</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-tabs fill>
                        <b-tab :title="`${getLanguage.tabCalendar}`" active>
                            <div class="wrapper-content">
                                <calendar></calendar>
                            </div>
                        </b-tab>
                        <b-tab :title="tabTitle">
                            <div class="wrapper-content">
                                <user></user>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="footer">
                    <p>powered by <a href="https://www.tennis-kalender.at" target="_blank">tennis-kalender.at</a> &bull;
                        <a href="https://www.tennis-kalender.at/datenschutz.php" target="_blank">{{ getLanguage.calendarText.privacy }}</a></p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import Calendar from './components/Calendar.vue';
    import User from './components/User.vue';
    import { mapActions, mapGetters } from 'vuex';
    import { CONFIG } from './shared';

    export default {
        name: 'app',
        components: { Calendar, User },
        data() {
            return {
                title: CONFIG.name,
                tab: '',
            }
        },
        methods: {
            ...mapActions(['checkLogin', 'getUserEvents']),
        },
        watch: {
            loginStatus(status) {
              this.tab = (status > 0) ? this.getLanguage.tabLoggedIn : this.getLanguage.tabLogin;
            }
        },
        async created() {
            // check login of user
            this.checkLogin();

            // userevents nur für normale user, sonst evt. wieder zu viele events hier ...
            if (this.loginStatus > 0 && !this.isAdmin) {
                await this.getUserEvents();
            }
        },
        computed: {
            ...mapGetters(['getUserId', 'getUserToken', 'userIsAdmin', 'getLanguage']),
            loginStatus() {
                return this.getUserId;
            },
            isAdmin() {
                return this.userIsAdmin;
            },
            userToken() {
                return this.getUserToken;
            },
            tabTitle() {
                return this.tab != '' ? this.tab : this.getLanguage.tabLogin;
            }
        }
    }
</script>

<style lang='scss'>
    @import '~bootstrap';
    @import '~bootstrap-vue';
    @import "./styles/base.scss";
</style>
